<template>
  <transition name="flip">
    <div class='content-file' :style='infoActive ? "padding: 0.5rem 0.5rem 0.5rem 0.5rem !important": ""' v-bind:key="infoActive">
      <div class='header-file'>
        <i class='material-icons is-size-7 icon-options' v-on:click='infoActive = !infoActive'>{{!infoActive ? "announcement" : "chevron_left"}}</i>
        <!-- Dropdown -->
        <div class="dropdown" tabindex='0' v-on:focusout='handleClickCloseDropdown' :class='active ? "is-active": ""'>
          <div class="dropdown-trigger">
            <i class='material-icons is-size-7 icon-options' v-on:click='switchDropdown'>more_vert</i>
          </div>
          <div class="dropdown-menu" id="dropdown-menu" role="menu">
            <div class="dropdown-content" style='max-width: 55%;'>
              <a class="dropdown-item" v-on:click='downloadFile()'>
                Descargar
              </a>
              <a v-if='tokenUser["admin"]' class="dropdown-item" v-on:click='deleteFile()'>
                Eliminar
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="file-label" v-if='!infoActive'>
        <img v-if='type === "excel"' src='@/assets/icons/excel.svg' width='64' height='64' alt='www.icons8.com'>
        <img v-if='type === "word"' src='@/assets/icons/word.svg' width='64' height='64' alt='www.icons8.com'>
        <img v-if='type === "pdf"' src='@/assets/icons/pdf.png' width='64' height='64' alt='www.icons8.com'>
        <img v-if='type === "notFile"' src='@/assets/icons/notFile.svg' width='64' height='64' alt='www.icons8.com'>
      </div>
      <div class="file-label" v-if='infoActive'>
        <div style='width: 100%'>
          <strong class='is-size-7'>Creado</strong>
          <div class='is-size-7'>{{infoFile.date}}</div>
        </div>
        <div style='width: 100%'>
          <strong class='is-size-7'>Extensión</strong>
          <div class='is-size-7'>{{infoFile.ex}}</div>
        </div>
        <div style='width: 100%'>
          <strong class='is-size-7'>Tamaño</strong>
          <div class='is-size-7'>{{infoFile.size}}</div>
        </div>
      </div>
      <span v-if='!infoActive' class='is-size-7 name-file' v-tooltip.bottom='name' style='padding-bottom: 5px!important;'>{{name}}</span>
    </div>
  </transition>
</template>
<script>
import {mapState} from 'vuex'

export default {
  data(){
    return {
      active: false,
      infoActive: false,
      infoFile: {},
      imgForType: {
        1: "excel",
        2: "word",
        3: "pdf",
        4: "notFile"
      },
      type: "",
      id: "dropdown-file"+new Date().getTime(),
      name: ""
    }
  },
  props:{
    file: Object
  },
  computed:{
    ...mapState(['tokenUser'])
  },
  beforeMount() {
    this.getImg()
    this.file.getMetadata().then((metadata) => {
      // Tamaño del archivo en bytes
      const sizeBytes = metadata.size;
      // Convertir el tamaño del archivo a megabytes
      const sizeMB = sizeBytes / 1048576;
      // Fecha de creación con formato
      let date = new Date(metadata.timeCreated);
      let options = {year: 'numeric', month: 'numeric', day: 'numeric'};
      date = date.toLocaleDateString(undefined, options);
      // Se guarda la información
      this.infoFile.size = sizeMB.toFixed(2)+ " MB";
      this.infoFile.date = date;
      this.infoFile.ex = metadata.name.split('.').pop();
    }).catch((error) => {
      console.error('Error al obtener metadatos:', error);
    });
    let name = ""
    this.file.name.split("-").map((e, k) => {
      if (k > 0){
        name += " "+e
      }
    })
    this.name = name;
  },
  methods:{
    downloadFile(){
      this.file.getDownloadURL().then(url => {
        const downloadLink = document.createElement("a");
        downloadLink.href = url; // La URL de descarga obtenida previamente
        downloadLink.download = this.name; // Nombre de archivo deseado
        downloadLink.textContent = "Descargar archivo"; // Texto del enlace
        downloadLink.id = "descarga-enlace"; // Identificador para el enlace
        document.body.appendChild(downloadLink);
        // Evento para eliminar el elemento
        document.getElementById("descarga-enlace").addEventListener("click", function() {
          setTimeout(function() {
            const linkToRemove = document.getElementById("descarga-enlace");
            if (linkToRemove) {
              linkToRemove.remove();
            }
          }, 1000);
        });

        downloadLink.click();

        this.$swal({
          text: 'Archivo descargado correctamente.',
          icon: 'success',
          showConfirmButton: false,
          timer: 1700
        })
        this.switchDropdown();

      }).catch(error => {
        this.$swal({
          text: 'Error al descargar el archivo.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1700
        })
        console.log(error)
      })

    },
    deleteFile(){
      const deleteFile = this.$fire.deleteAttached(this.file.fullPath)
      this.$swal({
        icon: 'info',
        html: 'Eliminando archivo...',
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading()
        },
        timer: 5000
      });
      deleteFile.then(async () => {
        this.$emit('getFiles')
        await this.$swal({
          text: 'Archivo eliminado correctamente.',
          icon: 'success',
          showConfirmButton: false,
          timer: 1700
        })
        this.$swal.close()
      }).catch(error => {
        this.$swal.close()
        this.$swal({
          text: 'Error al eliminar el archivo.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1700
        })
        console.log(error)
      })
    },
    // Helpers
    switchDropdown(){
      this.active = !this.active
    },
    getImg(){
      if (this.file.name.includes('.xlsx')){
        this.type = this.imgForType[1]
      }else if (this.file.name.includes('.docx')){
        this.type = this.imgForType[2]
      } else if (this.file.name.includes('.pdf')){
        this.type = this.imgForType[3]
      } else {
        this.type = this.imgForType[4]
      }
    },
    handleClickCloseDropdown(e){
      // Lógica para manejar el clic en el documento
      if (this.active){
        this.switchDropdown();
      }
    }
  },
}
</script>
<style lang=''>
.flip-enter-active {
  transition: all 0.4s ease;
}

.flip-leave-active {
  display: none;
}

.flip-enter, .flip-leave {
  transform: rotateY(180deg);
  opacity: 0;

}
</style>



// WEBPACK FOOTER //
// src/components/attached/components/cardFileUpload.vue